module.exports = __webpack_public_path__ + "static/media/adelina_dabu.447765d7.png";